import { createSlice } from '@reduxjs/toolkit'

const cancelSubscriptionStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: cancelSubscriptionStatus.LOADING,
    freeCourses: [],
    errorMessage: null,
    cancelStatus: cancelSubscriptionStatus.LOADING,
    cancelErrorMessage: null,
}

const cancelSubscriptionSlice = createSlice({
    name: 'cancelSubscription',
    initialState,
    reducers: {
        getFreeCoursesRequest: state => {
            state.status = cancelSubscriptionStatus.LOADING
        },
        getFreeCoursesRequestSuccess: (state, action) => {
            state.status = cancelSubscriptionStatus.SUCCESS
            state.freeCourses = action.payload
        },
        getFreeCoursesRequestError: (state, action) => {
            state.status = cancelSubscriptionStatus.FAILURE
            state.errorMessage = action.payload
        },
        cancelSubscriptionRequest: state => {
            state.cancelStatus = cancelSubscriptionStatus.LOADING
        },
        cancelSubscriptionRequestSuccess: (state, action) => {
            state.cancelStatus = cancelSubscriptionStatus.SUCCESS
        },
        cancelSubscriptionRequestError: (state, action) => {
            state.cancelStatus = cancelSubscriptionStatus.FAILURE
            state.cancelErrorMessage = action.payload
        },
    },
})

const {
    getFreeCoursesRequest,
    getFreeCoursesRequestSuccess,
    getFreeCoursesRequestError,
    cancelSubscriptionRequest,
    cancelSubscriptionRequestSuccess,
    cancelSubscriptionRequestError,
} = cancelSubscriptionSlice.actions

export const cancelSubscriptionActions = {
    getFreeCoursesRequest,
    getFreeCoursesRequestSuccess,
    getFreeCoursesRequestError,
    cancelSubscriptionRequest,
    cancelSubscriptionRequestSuccess,
    cancelSubscriptionRequestError,
}

export const cancelSubscriptionSelectors = {
    isFetching: state => {
        return {
            freeCourses:
                state.cancelSubscription.status ===
                cancelSubscriptionStatus.LOADING,
            cancelSubscription:
                state.cancelSubscription.cancelStatus ===
                cancelSubscriptionStatus.LOADING,
        }
    },
    hasError: state => {
        return {
            freeCourses:
                state.cancelSubscription.status ===
                cancelSubscriptionStatus.FAILURE,
            cancelSubscription:
                state.cancelSubscription.cancelStatus ===
                cancelSubscriptionStatus.FAILURE,
        }
    },
    errorMessage: state => {
        return {
            freeCourses: state.cancelSubscription.errorMessage,
            cancelSubscription: state.cancelSubscription.cancelErrorMessage,
        }
    },
    freeCourses: state => state.cancelSubscription.freeCourses,
    cancelSuccess: state =>
        state.cancelSubscription.cancelStatus ===
        cancelSubscriptionStatus.SUCCESS,
}

export const cancelSubscriptionReducer = cancelSubscriptionSlice.reducer
